/**
 * @license
 * Copyright (c) 2018 Crius Authors. All rights reserved.
 */

import '@polymer/polymer/polymer-element.js';

const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `<dom-module id="cs-shared-styles-form-tooltip">
  <template>
      <style>
        /** * Tooltip */
        .cspl-input__tooltip {
          color: var(--cs-dark-color);
          display: none;
          opacity: 0;
          pointer-events: none;
          top: 0;
          transition: all .25s cubic-bezier(.5, .25, .015, 1);
          z-index: 1;
        }

        :host([error][current]) .cspl-input__tooltip--error {
          opacity: 1;
          top: 68px;
        }

        :host([help-active]:not([error])) .cspl-input__tooltip--help {
          opacity: 1;
          top: 68px;
        }

        :host .cspl-input__tooltip {
          background: #fff;
          border-radius: 5px;
          box-shadow: 0 4px 18px rgba(0, 0, 0, .35);
          left: 2px;
          padding: 24px;
          position: absolute;
          width: 100%;
        }

        :host .cspl-input__tooltip::before {
          border-bottom: 8px solid #fff;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          content: "";
          left: calc(50% - 10px);
          position: absolute;
          top: -8px;
        }
      </style>
    </template>
  </dom-module>`;

document.head.appendChild($_documentContainer.content);
